<form class="featureGroupSearch" [formGroup]="searchForm" id="headerActions">
    <div class="featureGroupSearchWrapper">
        <label for="featureGroupSearch">
            <i class="far fa-search"></i>
        </label>
        <input
            type="text"
            placeholder="{{ 'listings.header.searchFeatureGroups' | translate }}"
            id="featureGroupSearch"
            formControlName="search"
        />
        @if (searchForm.controls['search']!.value) {
            <button class="button small transparent icon" (click)="clearSearch()">
                <i class="far fa-close"></i>
            </button>
        }
    </div>
</form>
